import { useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { connect } from 'react-redux';
import { EditProjectLink, ProjectLink } from '../links/index.jsx';
import { EditBlueIcon } from '../icons/EditBlueIcon.jsx';
import { DeleteBlueIcon } from '../icons/DeleteBlueIcon.jsx';
import { DuplicateIcon } from '../icons/DuplicateIcon.jsx';
import { selectUserPermissions } from '../../modules/auth.js';
import { isAuthorized } from '../AuthorizedAction.js';
import { EyeIcon } from '../icons/EyeIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';
import DuplicateProjectModal from './duplicate/DuplicateProjectModal.jsx';
import { duplicationText } from '../../constants/projectDuplication.js';

const mapStateToProps = (state) => ({
  permissions: selectUserPermissions(state),
});

const ProjectActionDropdown = ({
  projectId,
  project,
  permissions,
  onDeleteProject,
  className,
}) => {
  const location = useLocation();
  const route = location.pathname;
  const isProjectsIndexPage = route.match(/\/[^/]+\/projects$/);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  return (
    <div className={`actions flex-inline${className ? ` ${className}` : ''}`}>
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {isProjectsIndexPage ? (
          <ProjectLink projectId={projectId}>
            <CustomMenuItem>
              <span className="flex">
                <EyeIcon />
                <span>&nbsp; View</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </ProjectLink>
        ) : null}
        {project.manageProject ? (
          <EditProjectLink projectId={project.id}>
            <CustomMenuItem>
              <span className="flex">
                <EditBlueIcon />
                <span>&nbsp; Edit</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </EditProjectLink>
        ) : null}
        {/* A 403 signs the user out, so Duplicate is offered only when the backend allows it */}
        {project.canDuplicate ? (
          <span className="item">
            <CustomMenuItem onClick={() => setShowDuplicateModal(true)}>
              <span className="flex">
                <DuplicateIcon />
                <span>&nbsp; {duplicationText('menuItem')}</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </span>
        ) : null}
        {isAuthorized('update', 'project', permissions) ||
        isAuthorized('destroy', 'project', permissions) ? (
          <span className="item">
            <CustomMenuItem onClick={() => onDeleteProject(projectId)}>
              <span className="flex">
                <DeleteBlueIcon />
                <span>&nbsp; Delete</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </span>
        ) : null}
      </DropdownButton>
      {showDuplicateModal ? (
        <DuplicateProjectModal
          show
          project={project}
          onHide={() => setShowDuplicateModal(false)}
        />
      ) : null}
    </div>
  );
};

export default connect(mapStateToProps, null)(ProjectActionDropdown);
